export default __webpack_public_path__ + "static/media/laravel.6470b3d8.svg";